import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const CayleyHamiltonTheorem = () => (
  <QPhototModuleSubtopic
    title="Cayley Hamilton Theorem"
    videos={[
      "https://www.youtube.com/embed/ELW4Vxm-qsI",
      "https://www.youtube.com/embed/fi_8eS9SXMA",
      "https://www.youtube.com/embed/pjE6ksSchws"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_58.png"},
        {image:"/cvla_59.png"},
        {image:"/cvla_60.png"},
        {image:"/cvla_61.png"},
        {image:"/cvla_62.png"},

    ]}
    exampleVideos={[]}
  />
);

export default CayleyHamiltonTheorem;
